<div class="formly-input-container">
    <ion-item>
        <input [formControl]="ngControl" [minlength]="to.minLength" type="text" inputmode="numeric" pattern="[0-9 ]*"
      [mask]="$translatedMask()"
      placeholder="{{'CDC_AUTHENTICATION.CARD_NUMBER'|translate}}" (keyup)="cardMaskFunction(ngControl.value)"/>

    </ion-item>

    <div *ngIf="ngControl.dirty">
        <!-- circuito non accettato: motivo esplicito, non "carta non valida" (non è un errore dell'utente) -->
        <p *ngIf="ngControl.hasError('cardBrand')" class="invalid">{{ "CDC_AUTHENTICATION.AMEX_NOT_ACCEPTED" | translate }}</p>
        <p *ngIf="ngControl.invalid && !ngControl.hasError('cardBrand')" class="invalid">{{ "CDC_AUTHENTICATION.CARD_NOT_VALID" | translate }}</p>
        <p *ngIf="ngControl.valid" class="valid">{{ "CDC_AUTHENTICATION.CARD_VALID" | translate }}</p>
    </div>
</div>